export default{
  getSearchCommentsStatus: (state) => state.searchCommentsStatus,
  getSearchCommentsCourse: (state) => state.searchCommentsCourse,
  getSearchCommentsLesson: (state) => state.searchCommentsLesson
}



// WEBPACK FOOTER //
// ./src/components/comments/store/getters.js